module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-it-aa40a02b28313c37bad8ac28f598ae28.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-it.svg
// module id = d0ej
// module chunks = 23